export default "__VITE_ASSET__Cacl1wig__"